import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission through registered courier access",
      "Ideal for TPA international flyers",
      "Perfect for Port Tampa Bay cruise passengers",
      "Great for USF students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Hillsborough County post offices",
      "Good for planned international trips from TPA",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Hillsborough County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — about 4 hours from Tampa",
      "NPIC appointment required before traveling to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function TampaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Tampa"
      introText="Tampa travelers — TPA international flyers, cruise passengers sailing from Port Tampa Bay, USF students studying abroad, MacDill AFB military families, and Bay Area residents — have several options for getting a passport fast. Here is how they compare, and why most Tampa residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 4-hour trip to Miami."
      options={options}
      emergencyDescription="Tampa does not have its own regional passport agency. The closest agency is in Miami — about a 4-hour drive each way. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Miami Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Tampa does not have a regional passport agency — the closest is Miami, roughly 4 hours away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}